import { createSlice } from "@reduxjs/toolkit";
import { reset } from "../actions";

const initialState = {
  page: 0,
  data: {
    orderNumber: "",
    orderAmount: 0,
    orderForm: 29,
    orderStatus: 1,
    sampleAmount: "",
    dropBoxId: null,
    dropBoxDate: "",
    tableData: [],
  },
  billingInformation: {
    firstName: "",
    lastName: "",
    company: "",
    phone: "",
    email: "",
    shippingOption: "Dropbox",
    dropboxLocation: "",
    dropoffDate: "",
    billingMethod: "",
    purchasingAgentName: "",
    purchasingAgentEmail: "",
    poNumber: "",
    grantNumber:"",
    grantPi:"",
    grantNote:"",
    ccNumber: "",
    ccMonth: "",
    ccYear: "",
    cvv: "",
	ccZip: "",
    cardType: "",
    ccName: "",
    acgtCard: "",
  },
  primer: {
    primerList: [],
    primerAmount: "",
    banking: 0,
    comments: "",
    primerSynthesisList: [],
    synthesis: 0,
  },
};

const fsaFormSlice = createSlice({
  name: "fsaorderform",
  initialState,
  reducers: {
    //action creators
    initializeFsaTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          serviceOption: "",
          templateName: "",
          sequencingPrimer: "",
          length: "",
          reference: "",
          comments: "",
        };
        state.data.tableData.push(newObj);
      }
      return;
    },
    resetFsaState(state, action) {
      Object.assign(state, initialState);
      return;
    },
    resetFsaTableData(state, action) {
      state.data.tableData = action.payload;
      return;
    },
    setFsaSampleAmount(state, action) {
      state.data.sampleAmount = parseInt(action.payload);
      return;
    },
    addFsaRow(state, action) {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.data.tableData.push(newRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, index) => ({
        ...item,
        id: index + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    editFsaRow(state, action) {
      const { index, value, input } = action.payload;
      let pattern = /^[a-zA-Z0-9-_]{0,20}$/;

      const updatedData = [...state.data.tableData.map((obj) => ({ ...obj }))];

      if (input === "templateName") {
        if (pattern.test(value)) {
          updatedData[index][input] = value;
        } else {
          // You may want to handle this case differently, e.g., show an error message
          alert(
            "Only special characters allowed: hyphen( - ) and underscore( _ )."
          );
          return;
        }
      } else {
        updatedData[index][input] = value;
      }

      // Assuming your state has a property named "tableData"
      state.data.tableData = updatedData;
    },
    copyFsaRow(state, action) {
      const { index } = action.payload;
      const rowToCopy = state.data.tableData[index];

      // Create a copy of the row with a new id
      const copiedRow = {
        ...rowToCopy,
        id: state.data.tableData.length + 1, // Assign a new id or adjust as needed
      };

      // Insert the copied row at a specific position (e.g., next to the original row)
      state.data.tableData.splice(index + 1, 0, copiedRow);

      // Reset the indices in the updated tableData
      state.data.tableData = state.data.tableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));
      state.data.sampleAmount = parseInt(state.data.sampleAmount + 1);
      return;
    },
    deleteFsaRow(state, action) {
      const { index } = action.payload;      
      const updatedTableData = state.data.tableData.filter(
        (item, i) => i !== index
      );

      // Reset the indices in the updated tableData
      const resetIndexedTableData = updatedTableData.map((item, i) => ({
        ...item,
        id: i + 1,
      }));

      // Update the tableData state
      state.data.tableData = resetIndexedTableData;
      state.data.sampleAmount = parseInt(state.data.sampleAmount - 1);
      return;
    },
    toggleFsaCheckbox(state, action) {
      const { index, property } = action.payload;
      const newData = [...state.data.tableData];
      newData[index][property] = !newData[index][property];
      state.data.tableData = newData;
    },
    increaseFsaConcentration(state, action) {
      const { index, property } = action.payload;
      state.data.tableData[index][property] += 1;
    },
    decreaseFsaConcentration(state, action) {
      const { index, property } = action.payload;
      if (state.data.tableData[index][property] > 0) {
        state.data.tableData[index][property] -= 1;
      }
    },
    clearFsaSelect(state, action) {
      const { index, property } = action.payload;

      state.data.tableData[index] = {
        ...state.data.tableData[index],
        [property]: "", // Set the specified property to an empty string for the specific row
      };

      return;
    },
    fsaPrevStep: (state, action) => {
      state.page = state.page - 1;
    },
    fsaNextStep: (state, action) => {
      state.page = state.page + 1;
    },
    fsaSetStep: (state, action) => {
      state.page = action.payload;
    },
    resetFsaPage: (state, action) => {
      state.page = action.payload;
    },
    initializeFsaPrimerTableData(state, action) {
      for (let i = 0; i < action.payload; i++) {
        const newObj = {
          id: i + 1,
          pName: "",
          pSequence: "",
        };
        state.primer.primerSynthesisList.push(newObj);
      }
      return;
    },
    resetFsaPrimerTableData(state, action) {
      state.primer.primerSynthesisList = action.payload;
    },
    setFsaPrimerAmount(state, action) {
      state.primer.primerAmount = parseInt(action.payload);
      return;
    },
    addFsaPrimerRow: (state, action) => {
      const newRow = action.payload;
      // Add the new row to the end of tableData
      state.primer.primerSynthesisList.push(newRow);

      // Reset the indices in the updated tableData
      state.primer.primerSynthesisList = state.primer.primerSynthesisList.map(
        (item, index) => ({
          ...item,
          id: index + 1,
        })
      );
      state.primer.primerAmount = parseInt(state.primer.primerAmount + 1);
      return;
    },
    editFsaPrimerRow(state, action) {
      const { index, property, value } = action.payload;
      let pattern = /^[a-zA-Z0-9_-]*$/;
      const updatedData = [...state.primer.primerSynthesisList];

      if (property === "pSequence" || property === "pName") {
        if (pattern.test(value)) {
          updatedData[index][property] = value;
        } else {
          return;
        }
      } else {
        updatedData[index][property] = value;
      }

      // Assuming your state has a property named "tableData"
      state.primer.primerSynthesisList = updatedData;
    },
    deleteAllFsaPrimer(state, action) {
      state.primer.primerSynthesisList = action.payload;
      state.primer.primerAmount = "";
      return;
    },
    setFsaPrimerBanking(state, action) {
      state.primer.banking = action.payload;
      return;
    },
    setFsaPrimerList(state, action) {
      const list = action.payload.split(/,\s|\n|,/);
      state.primer.primerList = list;
      // console.log(state.primer.primerList);
      return;
    },
    setFsaPrimerSynthesis(state, action) {
      state.primer.synthesis = action.payload;
      return;
    },
    setFsaPrimerComments(state, action) {
      state.primer.comments = action.payload;
      return;
    },
    setFsaDropboxLocation(state, action) {
      state.billingInformation.dropboxLocation = action.payload.label;
      return;
    },
    setFsaDropboxId(state, action) {
      state.data.dropBoxId = action.payload;
      return;
    },
    setFsaDropoffDate(state, action) {
      state.billingInformation.dropoffDate = action.payload;
      state.data.dropBoxDate = action.payload;
      // Test the regular expression with a date
      // if (dateRegex.test(result)) {
      // }
    },
    setFsaFirstName(state, action) {
      state.billingInformation.firstName = action.payload;
      return;
    },
    setFsaLastName(state, action) {
      state.billingInformation.lastName = action.payload;
      return;
    },
    setFsaCompany(state, action) {
      state.billingInformation.company = action.payload;
    },
    setFsaPhone(state, action) {
      const phoneRegex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;
      const result = action.payload;

      // Test the regular expression with a date
      // if (phoneRegex.test(result)) {
      //   state.billingInformation.phone = result;
      // }
      state.billingInformation.phone = result;
    },
    setFsaEmail(state, action) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      state.billingInformation.email = action.payload;
    },
    setFsaShippingOption(state, action) {
      state.billingInformation.shippingOption = action.payload;
      return;
    },
    setFsaAcgtCard(state, action) {
      state.billingInformation.acgtCard = action.payload;
      return;
    },
    setFsaCCNumber(state, action) {
      state.billingInformation.ccNumber = action.payload;
      return;
    },
    setFsaCCMonth(state, action) {
      state.billingInformation.ccMonth = action.payload;
      return;
    },
    setFsaCCYear(state, action) {
      state.billingInformation.ccYear = action.payload;
      return;
    },
    setFsaCVV(state, action) {
      state.billingInformation.cvv = action.payload;
      return;
    },
	setFsaCCZip(state, action) {
      state.billingInformation.ccZip = action.payload;
      return;
    },
    setFsaCCName(state, action) {
      state.billingInformation.ccName = action.payload;
      return;
    },
    setFsaCardType(state, action) {
      state.billingInformation.cardType = action.payload;
      return;
    },
    setFsaBillingMethod(state, action) {
      state.billingInformation.billingMethod = action.payload;
      return;
    },
    setFsaPurchasingAgentName(state, action) {
      state.billingInformation.purchasingAgentName = action.payload;
      return;
    },
    setFsaPurchasingAgentEmail(state, action) {
      state.billingInformation.purchasingAgentEmail = action.payload;
      return;
    },
    setFsaPoNumber(state, action) {
      state.billingInformation.poNumber = action.payload;
      return;
    },
    setFsaEstimate(state, action) {
      state.data.orderAmount = action.payload;
      return;
    },
    setFsaOrderNumber(state, action) {
      state.data.orderNumber = action.payload
    },
    setFsaOrderAmount(state, action) {
      state.data.orderAmount = action.payload
    },
    setFsaGrantNumber(state, action) {
      state.billingInformation.grantNumber = action.payload;
      return;
    },
    setFsaGrantPI(state, action) {
      state.billingInformation.grantPi = action.payload;
      return;
    },
    setFsaGrantNote(state, action) {
      state.billingInformation.grantNote = action.payload;
      return;
    },
  },
  //tell our combined reducer to look for additional action types
  extraReducers(builder) {
    builder.addCase(reset, (state, action) => {
      return {};
    });
  },
});

export const {
  initializeFsaTableData,
  resetFsaState,
  resetFsaTableData,
  setFsaSampleAmount,
  addFsaRow,
  editFsaRow,
  copyFsaRow,
  deleteFsaRow,
  toggleFsaCheckbox,
  increaseFsaConcentration,
  decreaseFsaConcentration,
  clearFsaSelect,
  fsaNextStep,
  fsaPrevStep,
  fsaSetStep,
  resetFsaPage,
  initializeFsaPrimerTableData,
  resetFsaPrimerTableData,
  setFsaPrimerAmount,
  addFsaPrimerRow,
  editFsaPrimerRow,
  deleteAllFsaPrimer,
  setFsaPrimerBanking,
  setFsaPrimerList,
  setFsaPrimerSynthesis,
  setFsaPrimerComments,
  setFsaDropoffDate,
  setFsaDropboxLocation,
  setFsaDropboxId,
  setFsaFirstName,
  setFsaLastName,
  setFsaCompany,
  setFsaPhone,
  setFsaEmail,
  setFsaShippingOption,
  setFsaAcgtCard,
  setFsaCCNumber,
  setFsaCCMonth,
  setFsaCCYear,
  setFsaCVV,
  setFsaCCZip,
  setFsaCCName,
  setFsaCardType,
  setFsaPurchasingAgentName,
  setFsaPurchasingAgentEmail,
  setFsaPoNumber,
  setFsaEstimate,
  setFsaGrantNote,
  setFsaGrantNumber,
  setFsaOrderNumber,
  setFsaOrderAmount,
  setFsaGrantPI,
  setFsaBillingMethod,
} = fsaFormSlice.actions;

export const fsaFormReducer = fsaFormSlice.reducer;
